import { render } from "./QVPKidsExamCenter.vue?vue&type=template&id=e6c6161c&scoped=true"
import script from "./QVPKidsExamCenter.vue?vue&type=script&lang=js"
export * from "./QVPKidsExamCenter.vue?vue&type=script&lang=js"

import "./QVPKidsExamCenter.vue?vue&type=style&index=0&id=e6c6161c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c6161c"]])

export default __exports__